"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validations = exports.validateOtherInput = exports.validateMinMaxOptions = exports["default"] = void 0;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.array.map.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _checkboxGroup = _interopRequireDefault(require("../../components/checkboxGroup"));
var _components = require("../../components");
var _lodash = _interopRequireDefault(require("lodash"));
var _validations2 = require("../../validations");
var _i18n = require("../../i18n");
var _excluded = ["submitting", "fieldSpacing", "ComponentWrapper", "dispatch", "config"],
  _excluded2 = ["other", "required", "minimum", "maximum"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var singleCheckboxProps = ['label', 'inputStyle', 'labelStyle', 'name', 'disabled', 'readOnly', 'input', 'meta', 'options', 'initialValue', 'labelTooltip'];
var Checkbox = function Checkbox(_ref) {
  var submitting = _ref.submitting,
    fieldSpacing = _ref.fieldSpacing,
    ComponentWrapper = _ref.ComponentWrapper,
    dispatch = _ref.dispatch,
    config = _ref.config,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (!props.options || _lodash["default"].isEmpty(props.options)) {
    var passProps = _lodash["default"].pick(props, singleCheckboxProps);
    return /*#__PURE__*/_react["default"].createElement(_components.CheckboxInput, (0, _extends2["default"])({}, passProps, {
      config: _objectSpread(_objectSpread({}, passProps), _lodash["default"].pick(config, singleCheckboxProps))
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(_checkboxGroup["default"], (0, _extends2["default"])({}, props, {
    config: _objectSpread(_objectSpread(_objectSpread({}, props), config), {}, {
      withNone: props["interface"] === 'checkboxgroupwithnone'
    })
  }));
};
var validations = exports.validations = function validations(_ref2) {
  var other = _ref2.other,
    required = _ref2.required,
    minimum = _ref2.minimum,
    maximum = _ref2.maximum,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  var _validations = [];
  if (other) _validations.push(validateOtherInput(props));
  if ((!props.options || _lodash["default"].isEmpty(props.options)) && required) _validations.push(_validations2.singleCheckboxMustBeChecked);
  if (minimum !== undefined || maximum !== undefined) _validations.push(validateMinMaxOptions({
    min: minimum,
    max: maximum
  }));
  return _validations;
};
var validateMinMaxOptions = exports.validateMinMaxOptions = function validateMinMaxOptions(_ref3) {
  var min = _ref3.min,
    max = _ref3.max;
  return function (selectedOptions, allValues, props, name) {
    if (allValues !== null && allValues !== void 0 && allValues["".concat(name, "_exclusive")]) {
      return undefined;
    }
    if (selectedOptions !== null && selectedOptions !== void 0 && selectedOptions.length && selectedOptions.includes('')) {
      return undefined;
    }
    var value = (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) || 0;
    if (min !== undefined && max !== undefined) {
      if (min <= value && max >= value) {
        return undefined;
      }
    } else {
      if (min !== undefined && value > min) {
        return undefined;
      } else if (max !== undefined && value < max) {
        return undefined;
      }
    }
    return (0, _i18n.globalTranslate)('validations.checkboxWithNone.minMaxOptions', {
      min: min,
      max: max
    });
  };
};

// diffs selected values with answers to determine if one of the values is the free text
// with 'other' selected there should be another value present that is not included in the answers
var validateOtherInput = exports.validateOtherInput = function validateOtherInput(_ref4) {
  var _ref4$options = _ref4.options,
    options = _ref4$options === void 0 ? [] : _ref4$options;
  return function (v) {
    var answers = options.map(function (opt) {
      return opt.answer;
    });
    if (_lodash["default"].includes(v, 'other') && _lodash["default"].difference(v, answers).length !== 2) return 'please enter a value';
  };
};
Checkbox.handlesErrorDisplay = true;
Checkbox.showWarningIconOnError = false;
var _default = exports["default"] = Checkbox;